
import type { SVGProps } from 'react';
const SvgKabinenserviceIsKabine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#kabinenservice-is-kabine_svg__a)">
      <path
        fill="#263E6A"
        fillRule="evenodd"
        d="M17.062 12.502h1.85c.6 0 1.088.488 1.088 1.087v4.004a.268.268 0 0 1-.536 0V13.59a.55.55 0 0 0-.551-.55h-.891v4.554a.268.268 0 0 1-.537 0v-.305H13.17v1.667h5.353a.268.268 0 0 1 0 .537h-6.78c-.57 0-1.039-.441-1.084-1h-.731c-.079.562-.56.995-1.143.995a1.156 1.156 0 0 1-1.143-.995h-.34c-.078.562-.56.995-1.142.995a1.156 1.156 0 0 1-1.144-.998A1.09 1.09 0 0 1 4 17.405V9.289c0-.6.488-1.088 1.087-1.088h.439V5.21c0-.667.542-1.21 1.21-1.21h2.06c.668 0 1.21.543 1.21 1.21V8.2h.491c.6 0 1.088.488 1.088 1.088v1.872a.268.268 0 0 1-.537 0V9.289a.55.55 0 0 0-.55-.551h-5.41a.55.55 0 0 0-.552.55v4.306h5.136a.268.268 0 0 1 0 .537H4.536v1.556h5.136a.268.268 0 0 1 0 .536H4.537v1.182c0 .304.247.551.55.551h5.568v-4.367c0-.6.488-1.087 1.088-1.087h1.85v-.818c0-.37.301-.67.67-.67h2.128c.37 0 .67.3.67.67zM6.735 4.536a.674.674 0 0 0-.673.674V8.2H9.47V5.21a.674.674 0 0 0-.673-.674zm-1.17 13.956c.071.264.31.459.595.459a.62.62 0 0 0 .595-.459zm2.625 0c.071.264.31.459.595.459a.62.62 0 0 0 .595-.459zm6.074-6.943a.136.136 0 0 0-.134.135v.818h2.395v-.818a.136.136 0 0 0-.134-.134zm3.221 3.118v-1.629H13.17v1.63zm-5.742 4.288h.89v-5.917h-.89a.55.55 0 0 0-.552.551v4.815c0 .304.248.551.551.551m1.427-3.751v1.548h4.315v-1.548zm-7.891-5.4c0-.148.12-.268.268-.268h4.455c.147 0 .268.12.268.268v1.967c0 .148-.12.268-.268.268H5.547a.27.27 0 0 1-.268-.268zm.536 1.698h3.918v-1.43H5.815z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="kabinenservice-is-kabine_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgKabinenserviceIsKabine;
